var _defs, _path, _circle, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#979b9e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gps_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,20.42A8.42,8.42,0,1,1,20.42,12,8.43,8.43,0,0,1,12,20.42ZM12,5a7,7,0,1,0,7,7A7,7,0,0,0,12,5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3.88
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28,12c0-.24,0-.47,0-.7H1.14a.7.7,0,0,0,0,1.4H4.31C4.29,12.47,4.28,12.24,4.28,12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4.28c.24,0,.47,0,.7,0V1.14a.7.7,0,1,0-1.4,0V4.31C11.53,4.29,11.76,4.28,12,4.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.86,11.3H19.69c0,.23,0,.46,0,.7s0,.47,0,.7h3.17a.7.7,0,0,0,0-1.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12,19.72c-.24,0-.47,0-.7,0v3.17a.7.7,0,0,0,1.4,0V19.69C12.47,19.71,12.24,19.72,12,19.72Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.eede12edb889217fe5d13b43020cfb26.svg";
export { ForwardRef as ReactComponent };